// extracted by mini-css-extract-plugin
export default {"noDeviceBackground":"noDeviceID_noDeviceBackground__IIN-y","noDeviceTitle":"noDeviceID_noDeviceTitle__DFLzA"};